import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { TableResult } from '../../../common/models';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  public constructor(private http: HttpClient) {}

  public list(
    isPaginated: boolean = false,
    page: number = 0,
    limit: number = 10,
    search: string = ''
  ): Observable<TableResult<any>> {
    const params = new HttpParams()
      .append('PagingEnabled', isPaginated)
      .append('PageNumber', page)
      .append('PageSize', limit)
      .append('FreeText', search);
    return this.http.get<TableResult<any>>(
      `${environment.apiUrl}/SubscriptionPlan/GetCountries`,
      { params }
    );
  }
}
